import { ReactComponent as SvgLoads } from '../icons/Loads.svg.js';
import { ReactComponent as SvgLorryFleetOwner } from '../icons/LorryFleetOwner.svg.js';
import { ReactComponent as SvgLorryTransportContractor } from '../icons/LorryTransportContractor.svg.js';
import { ReactComponent as SvgLorryAgentBroker } from '../icons/LorryAgentBroker.svg.js';

// Assets
const SERVICE_TYPE_OPTIONS = [
    {
        label: "I am a Shipper/Load Owner",
        value: "Shipper",
        description: "I have loads and I am searching for trucks",
        icon: SvgLoads
    },
    {
        label: "I am a Lorry Owner/Driver",
        value: "Fleet Owner",
        description: "I have truck(s) and I am looking for loads",
        icon: SvgLorryFleetOwner
    },
    {
        label: "I own/work for a Transport company",
        value: "Transport Contractor",
        description: "I am searching for both loads and lorries",
        icon: SvgLorryTransportContractor
    },
    {
        label: "I am an Agent/Broker",
        value: "Agent/Broker",
        description: "I don’t own loads or lorries but I act as a dealer between load and lorry owner",
        icon: SvgLorryAgentBroker
    }
];

export { SERVICE_TYPE_OPTIONS };
//# sourceMappingURL=ServiceType.js.map
